import {
	TRIGGER_SEND_MONEY_API,
	TRIGGER_SEND_MONEY_API_FAILURE,
	TRIGGER_SEND_MONEY_API_SUCCESS,
	TRIGGER_SET_SEND_MONEY_DETAILS,
} from 'redux/actionTypes';

export function triggerSendMoneyApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_SEND_MONEY_API,
		data,
		stopLoader,
		callback,
	};
}

export function triggerSendMoneyApiCallSuccess(data) {
	return {
		type: TRIGGER_SEND_MONEY_API_SUCCESS,
		data,
	};
}
export function triggerSendMoneyApiCallFailure(data) {
	return {
		type: TRIGGER_SEND_MONEY_API_FAILURE,
		data,
	};
}
